'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardDepartmentAdminCtrl', ['$uibModal', 'dialog', 'Department', 'Member', '$state','owners','departments', '$translate', 'myTenant', 'Authentication', 'myDepartments', require('./dashboardDepartmentAdminCtrl')]);
app.directive('department', require('./dashboardDepartmentAdminDirective'));
app.config(['$stateProvider', require('./dashboardDepartmentAdminConfig')]);
